"use strict";
exports.__esModule = true;
exports.focusIfIos = exports.isTouchDevice = exports.isIos = exports.sanitize = exports.nl2br = void 0;
var _a = window.MTBlockEditor.util, nl2br = _a.nl2br, sanitize = _a.sanitize, isIos = _a.isIos, isTouchDevice = _a.isTouchDevice, focusIfIos = _a.focusIfIos;
exports.nl2br = nl2br;
exports.sanitize = sanitize;
exports.isIos = isIos;
exports.isTouchDevice = isTouchDevice;
exports.focusIfIos = focusIfIos;
